// extracted by mini-css-extract-plugin
module.exports = {"msTouch":"_2hIbP","slider":"_2IOWJ","dots":"_29GMy"};